const MONTH_DAY_TIME = new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })

export function parse(iso: string | null | undefined): Date | null {
  if (!iso) return null
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? null : d
}

/** "Sep 22, 2:13 PM" */
export function monthDayTime(iso: string | null | undefined, empty = '–'): string {
  const d = parse(iso)
  return d ? MONTH_DAY_TIME.format(d) : empty
}
